export default {
      id: "financial-immunity-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#financial-immunity",
      toString: function () {
        return this.url;
      }
    }